import React from "react";
import "./footer.css";
import LOGO from "../../Assets/logo.svg";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        <img src={LOGO} alt="logo" />
      </a>

      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#skill">Skill</a>
        </li>
        <li>
          <a href="#contact">contact</a>
        </li>
      </ul>
      <div className="footer__copyright">
        <small>LEUL ADUGNA &copy; 2022-2024. All Rights Reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
